import { useIntl } from 'react-intl';
import { Box, Divider } from '@mui/material';
import type { ApiOrganization } from '@agunity/api-v4';

import AgButton from '../../../stories/Components/AgButton';
import AgTypography from '../../../stories/Styles/AgTypography';
import AgToggle from '../../../stories/Components/AgToggle';
import AgOrganizationalChips from '../../../stories/Chips/AgOrganizationalChips';
import AgChip from '../../../stories/Chips/AgChip';

import { AgColor } from '../../../stories/Styles/AgColor';

interface IOrganizationSettingsProps {
  editAccess: boolean;
  parentOrg?: ApiOrganization;
  handleActiveStatus?: () => void;
  activateBtnLabel?: string;
  deforestActive?: boolean;
  orgType?: string;
}

const OrganizationSettings = ({ editAccess, parentOrg, handleActiveStatus, activateBtnLabel, deforestActive, orgType }: IOrganizationSettingsProps) => {
  const messages = useIntl().formatMessage;

  return ( 
    <AgTypography
      style={{
        padding: '24px 16px',
        display: 'grid',
        gap: '16px'
      }}
    >
      {
        deforestActive && <>
          <AgTypography
            contentStyle={'AP.H5.UPPERCASE.Bold'}
            message={messages({ id: 'SET_FOR_DEFORESTATION_CHECKS' })}
            style={{ color: AgColor.grey6 }}
          />
          <AgTypography
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Box>
              <AgTypography
                contentStyle={'AP.Paragraph.Small.Regular'}
                // Will replace the text once the right text is available
                message={messages({ id: 'SET_FOR_DEFORESTATION_CHECKS_DESCRIPTION' })}
                style={{
                  width: '320px',
                  color: AgColor.grey7
                }}
              />
              <AgTypography
                contentStyle={'AP.Paragraph.Small.Link'}
              >
                <a
                  style={{ color: AgColor.link1, textDecoration: 'underline' }}
                  href='mailto:support@agunity.com'
                >support@agunity.com</a>
              </AgTypography>
            </Box>
            <AgToggle
              checked={false}
              onChange={() => {}}
              disabled={!editAccess}
            />
          </AgTypography>

          <Divider sx={{ margin: '16px 0' }} />
        </>
      }
      
      <AgTypography
        contentStyle={'AP.H5.UPPERCASE.Bold'}
        message={messages({ id: 'ORGANIZATION_TYPE' })}
        style={{ color: AgColor.grey6 }}
      />
      <Box display={'flex'}>
        <AgChip
          onClick={() => {}}
          type='organizations'
          label={orgType}
        />
      </Box>
      
      {
        parentOrg && (
          <>
            <AgTypography
              contentStyle={'AP.H5.UPPERCASE.Bold'}
              message={messages({ id: 'PARENT_ORGANIZATION' })}
              style={{ color: AgColor.grey6 }}
            />
            <Box display={'flex'}>
              <AgOrganizationalChips
                type='selected'
                label={parentOrg?.name ?? ''}
                orgId={String(parentOrg?.id)}
                width={'100%'}
                orgType={orgType}
              />
            </Box>
          </>
        )
      }

      {
        editAccess && (
          <>
            <Divider sx={{ margin: '16px 0' }} />
      
            <AgTypography
              contentStyle={'AP.H5.UPPERCASE.Bold'}
              message={messages({ id: 'DEACTIVATE_ORGANIZATION' })}
              style={{ color: AgColor.grey6 }}
            />
      
            <AgTypography
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <AgTypography
                contentStyle={'AP.Paragraph.Small.Regular'}
                // Will replace the text once the right text is available
                message={'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
                style={{
                  width: '320px',
                  color: AgColor.grey7
                }}
              />
              <AgButton label={activateBtnLabel ?? messages({ id: 'DEACTIVATE' })} variant={'outlined'} color='error' onClick={handleActiveStatus} />
            </AgTypography>
          </>
        )
      }
      
    </AgTypography>
  );
};
 
export default OrganizationSettings;